import groupedRequestDetailsStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IS_SAVING', function setIsSavingInStore(isSaving: boolean, isApproving: boolean) {
    groupedRequestDetailsStore.isSaving = isSaving;
    groupedRequestDetailsStore.isApproving = isApproving;
});
